import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, assetUrl } from "@/lib/api";
import { SectionTitle } from "@/components/ArticleCards";

export default function Archives() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/issues").then((r) => {
      setIssues(r.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="py-16 md:py-24" data-testid="archives-page">
      <div className="max-w-5xl mx-auto px-6">
        <SectionTitle subtitle="Browse all volumes and issues of Clinical & Surgical Review.">
          Archives
        </SectionTitle>

        {loading ? (
          <div className="text-center font-serif text-[#001F3F]/60">Loading…</div>
        ) : issues.length === 0 ? (
          <div className="text-center py-20 font-serif text-[#001F3F]/60 border border-dashed border-gray-200">
            No issues archived yet.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {issues.map((iss) => (
              <Link key={iss.id} to={`/archives/${iss.id}`} className="group bg-white border border-gray-200 p-6 hover:border-[#2BA6A6] transition-colors">
                {iss.cover_image_url && (
                  <img src={assetUrl(iss.cover_image_url)} alt="" className="w-full h-44 object-cover mb-4 border border-gray-100" />
                )}
                <div className="text-[11px] font-sans tracking-[0.2em] uppercase font-semibold text-[#2BA6A6] mb-2">
                  Volume {iss.volume} · Issue {iss.issue}
                </div>
                <h3 className="font-serif text-xl text-[#001F3F] group-hover:text-[#2BA6A6] transition-colors leading-snug">{iss.title || `${iss.year} Issue`}</h3>
                <div className="mt-2 text-xs font-sans text-gray-500">
                  {iss.publication_date || iss.year} · {(iss.article_ids || []).length} article(s)
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
